/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AddSyncMemberResponse } from '../model/addSyncMemberResponse';
import { AddSyncOrganizationResponse } from '../model/addSyncOrganizationResponse';
import { AddSyncProfileResponse } from '../model/addSyncProfileResponse';
import { AddSyncProviderResponse } from '../model/addSyncProviderResponse';
import { EditSyncMemberResponse } from '../model/editSyncMemberResponse';
import { EditSyncOrganizationResponse } from '../model/editSyncOrganizationResponse';
import { EditSyncProfileResponse } from '../model/editSyncProfileResponse';
import { EditSyncProviderResponse } from '../model/editSyncProviderResponse';
import { GetSyncMembersResponse } from '../model/getSyncMembersResponse';
import { GetSyncOrganizationResponse } from '../model/getSyncOrganizationResponse';
import { GetSyncProfilesResponse } from '../model/getSyncProfilesResponse';
import { RemoveSyncMemberResponse } from '../model/removeSyncMemberResponse';
import { RemoveSyncOrganizationResponse } from '../model/removeSyncOrganizationResponse';
import { RemoveSyncProfileResponse } from '../model/removeSyncProfileResponse';
import { RemoveSyncProviderResponse } from '../model/removeSyncProviderResponse';
import { SyncMember } from '../model/syncMember';
import { SyncOrganization } from '../model/syncOrganization';
import { SyncProfileAbsence } from '../model/syncProfileAbsence';
import { SyncProviderAbsence } from '../model/syncProviderAbsence';
import { SyncProviderDirectory } from '../model/syncProviderDirectory';
import { SyncProviderPresence } from '../model/syncProviderPresence';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { SynchronizationServiceInterface }                            from './synchronization.serviceInterface';


@Injectable()
export class SynchronizationService implements SynchronizationServiceInterface {

    protected basePath = 'http://localhost:8080/ServiceGateway/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addSyncMember1(organization?: string, login?: string, body?: SyncMember, observe?: 'body', reportProgress?: boolean): Observable<AddSyncMemberResponse>;
    public addSyncMember1(organization?: string, login?: string, body?: SyncMember, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddSyncMemberResponse>>;
    public addSyncMember1(organization?: string, login?: string, body?: SyncMember, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddSyncMemberResponse>>;
    public addSyncMember1(organization?: string, login?: string, body?: SyncMember, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<AddSyncMemberResponse>(`${this.basePath}/synchronization/syncmember`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addSyncOrganization1(organization?: string, login?: string, body?: SyncOrganization, observe?: 'body', reportProgress?: boolean): Observable<AddSyncOrganizationResponse>;
    public addSyncOrganization1(organization?: string, login?: string, body?: SyncOrganization, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddSyncOrganizationResponse>>;
    public addSyncOrganization1(organization?: string, login?: string, body?: SyncOrganization, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddSyncOrganizationResponse>>;
    public addSyncOrganization1(organization?: string, login?: string, body?: SyncOrganization, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<AddSyncOrganizationResponse>(`${this.basePath}/synchronization/syncorganization`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addSyncProfile1(organization?: string, login?: string, body?: SyncProfileAbsence, observe?: 'body', reportProgress?: boolean): Observable<AddSyncProfileResponse>;
    public addSyncProfile1(organization?: string, login?: string, body?: SyncProfileAbsence, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddSyncProfileResponse>>;
    public addSyncProfile1(organization?: string, login?: string, body?: SyncProfileAbsence, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddSyncProfileResponse>>;
    public addSyncProfile1(organization?: string, login?: string, body?: SyncProfileAbsence, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<AddSyncProfileResponse>(`${this.basePath}/synchronization/syncprofile`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addSyncProvider1(organization?: string, login?: string, body?: SyncProviderAbsence, observe?: 'body', reportProgress?: boolean): Observable<AddSyncProviderResponse>;
    public addSyncProvider1(organization?: string, login?: string, body?: SyncProviderAbsence, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddSyncProviderResponse>>;
    public addSyncProvider1(organization?: string, login?: string, body?: SyncProviderAbsence, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddSyncProviderResponse>>;
    public addSyncProvider1(organization?: string, login?: string, body?: SyncProviderAbsence, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<AddSyncProviderResponse>(`${this.basePath}/synchronization/syncprovider`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addSyncProviderDirectory1(organization?: string, login?: string, body?: SyncProviderDirectory, observe?: 'body', reportProgress?: boolean): Observable<AddSyncProviderResponse>;
    public addSyncProviderDirectory1(organization?: string, login?: string, body?: SyncProviderDirectory, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddSyncProviderResponse>>;
    public addSyncProviderDirectory1(organization?: string, login?: string, body?: SyncProviderDirectory, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddSyncProviderResponse>>;
    public addSyncProviderDirectory1(organization?: string, login?: string, body?: SyncProviderDirectory, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<AddSyncProviderResponse>(`${this.basePath}/synchronization/syncproviderdirectory`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addSyncProviderPresence1(organization?: string, login?: string, body?: SyncProviderPresence, observe?: 'body', reportProgress?: boolean): Observable<AddSyncProviderResponse>;
    public addSyncProviderPresence1(organization?: string, login?: string, body?: SyncProviderPresence, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddSyncProviderResponse>>;
    public addSyncProviderPresence1(organization?: string, login?: string, body?: SyncProviderPresence, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddSyncProviderResponse>>;
    public addSyncProviderPresence1(organization?: string, login?: string, body?: SyncProviderPresence, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<AddSyncProviderResponse>(`${this.basePath}/synchronization/syncproviderpresence`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editSyncMember1(organization?: string, login?: string, body?: SyncMember, observe?: 'body', reportProgress?: boolean): Observable<EditSyncMemberResponse>;
    public editSyncMember1(organization?: string, login?: string, body?: SyncMember, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EditSyncMemberResponse>>;
    public editSyncMember1(organization?: string, login?: string, body?: SyncMember, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EditSyncMemberResponse>>;
    public editSyncMember1(organization?: string, login?: string, body?: SyncMember, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EditSyncMemberResponse>(`${this.basePath}/synchronization/syncmember`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editSyncOrganization1(organization?: string, login?: string, body?: SyncOrganization, observe?: 'body', reportProgress?: boolean): Observable<EditSyncOrganizationResponse>;
    public editSyncOrganization1(organization?: string, login?: string, body?: SyncOrganization, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EditSyncOrganizationResponse>>;
    public editSyncOrganization1(organization?: string, login?: string, body?: SyncOrganization, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EditSyncOrganizationResponse>>;
    public editSyncOrganization1(organization?: string, login?: string, body?: SyncOrganization, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EditSyncOrganizationResponse>(`${this.basePath}/synchronization/syncorganization`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editSyncProfile1(organization?: string, login?: string, body?: SyncProfileAbsence, observe?: 'body', reportProgress?: boolean): Observable<EditSyncProfileResponse>;
    public editSyncProfile1(organization?: string, login?: string, body?: SyncProfileAbsence, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EditSyncProfileResponse>>;
    public editSyncProfile1(organization?: string, login?: string, body?: SyncProfileAbsence, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EditSyncProfileResponse>>;
    public editSyncProfile1(organization?: string, login?: string, body?: SyncProfileAbsence, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EditSyncProfileResponse>(`${this.basePath}/synchronization/syncprofile`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editSyncProvider1(organization?: string, login?: string, body?: SyncProviderAbsence, observe?: 'body', reportProgress?: boolean): Observable<EditSyncProviderResponse>;
    public editSyncProvider1(organization?: string, login?: string, body?: SyncProviderAbsence, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EditSyncProviderResponse>>;
    public editSyncProvider1(organization?: string, login?: string, body?: SyncProviderAbsence, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EditSyncProviderResponse>>;
    public editSyncProvider1(organization?: string, login?: string, body?: SyncProviderAbsence, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EditSyncProviderResponse>(`${this.basePath}/synchronization/syncprovider`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editSyncProviderDirectory1(organization?: string, login?: string, body?: SyncProviderDirectory, observe?: 'body', reportProgress?: boolean): Observable<EditSyncProviderResponse>;
    public editSyncProviderDirectory1(organization?: string, login?: string, body?: SyncProviderDirectory, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EditSyncProviderResponse>>;
    public editSyncProviderDirectory1(organization?: string, login?: string, body?: SyncProviderDirectory, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EditSyncProviderResponse>>;
    public editSyncProviderDirectory1(organization?: string, login?: string, body?: SyncProviderDirectory, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EditSyncProviderResponse>(`${this.basePath}/synchronization/syncproviderdirectory`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editSyncProviderPresence1(organization?: string, login?: string, body?: SyncProviderPresence, observe?: 'body', reportProgress?: boolean): Observable<EditSyncProviderResponse>;
    public editSyncProviderPresence1(organization?: string, login?: string, body?: SyncProviderPresence, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EditSyncProviderResponse>>;
    public editSyncProviderPresence1(organization?: string, login?: string, body?: SyncProviderPresence, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EditSyncProviderResponse>>;
    public editSyncProviderPresence1(organization?: string, login?: string, body?: SyncProviderPresence, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EditSyncProviderResponse>(`${this.basePath}/synchronization/syncproviderpresence`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSyncMembers1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetSyncMembersResponse>;
    public getSyncMembers1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetSyncMembersResponse>>;
    public getSyncMembers1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetSyncMembersResponse>>;
    public getSyncMembers1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetSyncMembersResponse>(`${this.basePath}/synchronization/syncmember`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSyncOrganization1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetSyncOrganizationResponse>;
    public getSyncOrganization1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetSyncOrganizationResponse>>;
    public getSyncOrganization1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetSyncOrganizationResponse>>;
    public getSyncOrganization1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetSyncOrganizationResponse>(`${this.basePath}/synchronization/syncorganization`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSyncProfiles1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetSyncProfilesResponse>;
    public getSyncProfiles1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetSyncProfilesResponse>>;
    public getSyncProfiles1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetSyncProfilesResponse>>;
    public getSyncProfiles1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetSyncProfilesResponse>(`${this.basePath}/synchronization/syncprofile`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeSyncMember1(organization?: string, login?: string, body?: SyncMember, observe?: 'body', reportProgress?: boolean): Observable<RemoveSyncMemberResponse>;
    public removeSyncMember1(organization?: string, login?: string, body?: SyncMember, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RemoveSyncMemberResponse>>;
    public removeSyncMember1(organization?: string, login?: string, body?: SyncMember, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RemoveSyncMemberResponse>>;
    public removeSyncMember1(organization?: string, login?: string, body?: SyncMember, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.delete<RemoveSyncMemberResponse>(`${this.basePath}/synchronization/syncmember`,
            {
              body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            } as any
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeSyncMemberAbsence1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<RemoveSyncMemberResponse>;
    public removeSyncMemberAbsence1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RemoveSyncMemberResponse>>;
    public removeSyncMemberAbsence1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RemoveSyncMemberResponse>>;
    public removeSyncMemberAbsence1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<RemoveSyncMemberResponse>(`${this.basePath}/synchronization/syncmemberabsence`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeSyncOrganization1(organization?: string, login?: string, body?: SyncOrganization, observe?: 'body', reportProgress?: boolean): Observable<RemoveSyncOrganizationResponse>;
    public removeSyncOrganization1(organization?: string, login?: string, body?: SyncOrganization, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RemoveSyncOrganizationResponse>>;
    public removeSyncOrganization1(organization?: string, login?: string, body?: SyncOrganization, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RemoveSyncOrganizationResponse>>;
    public removeSyncOrganization1(organization?: string, login?: string, body?: SyncOrganization, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.delete<RemoveSyncOrganizationResponse>(`${this.basePath}/synchronization/syncorganization`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            } as any
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param profileId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeSyncProfile1(organization?: string, login?: string, profileId?: number, observe?: 'body', reportProgress?: boolean): Observable<RemoveSyncProfileResponse>;
    public removeSyncProfile1(organization?: string, login?: string, profileId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RemoveSyncProfileResponse>>;
    public removeSyncProfile1(organization?: string, login?: string, profileId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RemoveSyncProfileResponse>>;
    public removeSyncProfile1(organization?: string, login?: string, profileId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (profileId !== undefined && profileId !== null) {
            queryParameters = queryParameters.set('profileId', <any>profileId);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<RemoveSyncProfileResponse>(`${this.basePath}/synchronization/syncprofile`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeSyncProvider1(organization?: string, login?: string, body?: SyncProviderAbsence, observe?: 'body', reportProgress?: boolean): Observable<RemoveSyncProviderResponse>;
    public removeSyncProvider1(organization?: string, login?: string, body?: SyncProviderAbsence, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RemoveSyncProviderResponse>>;
    public removeSyncProvider1(organization?: string, login?: string, body?: SyncProviderAbsence, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RemoveSyncProviderResponse>>;
    public removeSyncProvider1(organization?: string, login?: string, body?: SyncProviderAbsence, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.delete<RemoveSyncProviderResponse>(`${this.basePath}/synchronization/syncprovider`,
            {
              body: body,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
            } as any
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeSyncProviderAbsence1(id: number, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<RemoveSyncProviderResponse>;
    public removeSyncProviderAbsence1(id: number, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RemoveSyncProviderResponse>>;
    public removeSyncProviderAbsence1(id: number, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RemoveSyncProviderResponse>>;
    public removeSyncProviderAbsence1(id: number, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling removeSyncProviderAbsence1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<RemoveSyncProviderResponse>(`${this.basePath}/synchronization/syncproviderabsence/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeSyncProviderDirectory1(id: number, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<RemoveSyncProviderResponse>;
    public removeSyncProviderDirectory1(id: number, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RemoveSyncProviderResponse>>;
    public removeSyncProviderDirectory1(id: number, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RemoveSyncProviderResponse>>;
    public removeSyncProviderDirectory1(id: number, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling removeSyncProviderDirectory1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<RemoveSyncProviderResponse>(`${this.basePath}/synchronization/syncproviderdirectory/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeSyncProviderPresence1(id: number, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<RemoveSyncProviderResponse>;
    public removeSyncProviderPresence1(id: number, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RemoveSyncProviderResponse>>;
    public removeSyncProviderPresence1(id: number, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RemoveSyncProviderResponse>>;
    public removeSyncProviderPresence1(id: number, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling removeSyncProviderPresence1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<RemoveSyncProviderResponse>(`${this.basePath}/synchronization/syncproviderpresence/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
